import React from "react";
import classes from "./Security.module.css";
import { Button, Text } from "components/common";
import clsx from "clsx";
import { FaPlus } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
const TwoFactorItem = ({ label, value, onClick }) => {
  return (
    <div className={clsx(classes.infoBox, classes.twoFaContainer)}>
      <Text sm primitive500>
        {label}
      </Text>
      <Text textRight font600 primitive700>
        {value || "_"}
      </Text>
      <Button
        transparent
        className={clsx(value ? classes.removeButton : classes.addButton)}
        onClick={onClick}
      >
        {value ? (
          <MdClose className={classes.icon} />
        ) : (
          <FaPlus className={classes.icon} />
        )}
      </Button>
    </div>
  );
};

export default TwoFactorItem;
